module.exports = __webpack_public_path__ + "static/media/scholorimg-2.d83c17e5.png";